module.exports = __webpack_public_path__ + "img/5-2.b7d7c758.png";